import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { Project } from '../../../../../model/project.model';
import { StoreService } from '../../../../../services/store.service';

@Component({
  selector: 'app-project-select-dialog',
  templateUrl: './project-select-dialog.component.html',
  styleUrls: ['./project-select-dialog.components.scss']
})
export class ProjectSelectDialogComponent implements AfterViewInit {

  @ViewChild('input') input: ElementRef<HTMLInputElement>;
  projectControl = new FormControl('');
  projects: Project[] = this._store.projects;
  filteredOptions: Project[];
  selectedProject: Project;

  constructor(
    public dialogRef: MatDialogRef<ProjectSelectDialogComponent>,
    private _store: StoreService
  ) {
    this.filteredOptions = this.projects.slice();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.input?.nativeElement.focus();
    }, 100)
  }

  getOptionText(option: Project) {
    return option.name;
  }

  filter(): void {
    const filterValue = this.input.nativeElement.value.toLowerCase();
    this.filteredOptions = this.projects.filter(p => p.name.toLowerCase().includes(filterValue));
  }

  clear(): void {
    this.projectControl.setValue("");
    this.projectControl.updateValueAndValidity();
    this.filter();
  }
  change(event: MatAutocompleteSelectedEvent) {
    this.selectedProject = event.option.value;
    this._store.setSelectedProject(this.selectedProject)
    this.dialogRef.close();
  }
}
